import React from 'react';
import { Container, Box, Typography, Paper, Alert } from '@mui/material';
import { Navigate } from 'react-router-dom';
import TelegramLoginButton from '../components/TelegramLoginButton';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const { isAuthenticated, loading, error } = useAuth();
  
  // Если пользователь авторизован, перенаправляем на главную страницу
  if (isAuthenticated) {
    return <Navigate to="/" />;
  }
  
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Typography component="h1" variant="h5" gutterBottom>
            TgBOTRise Admin
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ mb: 4, textAlign: 'center' }}>
            Войдите в систему, используя Telegram для управления ботом
          </Typography>
          
          {error && (
            <Alert severity="error" sx={{ mb: 2, width: '100%' }}>
              {error}
            </Alert>
          )}
          
          {loading ? (
            <Typography>Загрузка...</Typography>
          ) : (
            <TelegramLoginButton botName={process.env.REACT_APP_TELEGRAM_BOT_NAME || 'your_bot_name'} />
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginPage; 